// V2 save handler (newUserManagementEnabled: ON)

import { getTeams as getTeamsCaller } from 'state/callers';
import useDispatchify from 'common/hooks/utils/useDispatchify';
import * as teamServiceV2 from 'common/services/teams.v2.service';
import { parseResponseMsg } from 'common/utils/utils';
import { lbToast } from '@linearb/buzz';

const useTeamSaveHandler = ({
  team,
  teamForm,
  members,
  parentGroup,
  nestedTeams
} = {}) => {
  const getTeams = useDispatchify(getTeamsCaller);

  const toastMessage = ({ message, variant }) =>
    lbToast({ description: message, variant, autoHideDuration: 5000 });

  const generateRequestPayload = () => {
    const parentTeamId = parentGroup?.[0]?.id;
    const parentTeamName = parentGroup?.[0]?.name;
    const childTeamIds = (nestedTeams || []).map(({ id }) => id);
    const userIds = (members || []).map(({ id }) => ({ id }));

    return {
      name: teamForm.name,
      initials: teamForm.initials,
      color: teamForm.color,
      ...(parentTeamId && { parentTeamId }),
      ...(parentTeamName && { parentTeamName }),
      ...(childTeamIds?.length && { childTeamIds }),
      ...(userIds?.length && { userIds })
    };
  };

  const save = async ({ onSuccess, onError } = {}) => {
    const isEditMode = !!team?.id;
    const payload = generateRequestPayload();

    try {
      if (isEditMode) {
        await teamServiceV2.updateTeam(team.id, payload);
      } else {
        await teamServiceV2.createTeam(payload);
      }
      getTeams();
      onSuccess?.();

      toastMessage({
        message: `The team has been successfully ${
          isEditMode ? 'updated' : 'created'
        }. Changes may take a few minutes to process.`,
        variant: 'success'
      });
    } catch (e) {
      const errMsg = parseResponseMsg(e);
      toastMessage({
        message: errMsg,
        variant: 'destructive'
      });
      onError?.(e);
    }
  };

  return { save };
};

export default useTeamSaveHandler;
